import { theme } from '../theme';
import { fmtPlanNum } from '../utils/plan-pad';

const { ink, sub, line } = theme.colors;

/**
 * Две radio-карточки ритма траты — «Повседневная» / «Нерегулярная».
 * perDay != null → длинные подписи с расчётом ≈+N ₽/день.
 * perDay == null → короткие подписи (форма создания).
 */
export function RhythmCards(props: {
  daily: boolean;
  onChange: (daily: boolean) => void;
  /** ≈+N ₽/день в подписи «Повседневной»; null — короткие подписи (форма создания). */
  perDay: number | null;
}): JSX.Element {
  const { daily, onChange, perDay } = props;

  const cards: Array<{ id: boolean; title: string; note: string }> = [
    {
      id: true,
      title: 'Повседневная',
      note:
        perDay != null
          ? `входит в дневной лимит · ≈+${fmtPlanNum(perDay)} ₽/день`
          : 'входит в дневной лимит',
    },
    {
      id: false,
      title: 'Нерегулярная',
      note:
        perDay != null
          ? 'конверт месяца — вскрываешь, когда пришёл счёт'
          : 'конверт месяца',
    },
  ];

  return (
    <>
      {cards.map(({ id, title, note }) => {
        const selected = daily === id;
        return (
          <button
            key={String(id)}
            type="button"
            onClick={() => {
              if (!selected) onChange(id);
            }}
            style={{
              display: 'block',
              width: '100%',
              boxSizing: 'border-box',
              textAlign: 'left',
              marginTop: 8,
              padding: '10px 13px',
              background: 'transparent',
              borderRadius: theme.radius.sm,
              border: selected ? `1.5px solid ${ink}` : `1px solid ${line}`,
              cursor: 'pointer',
              fontFamily: theme.font,
            }}
          >
            <div style={{ fontSize: 15, color: selected ? ink : sub }}>
              {title}
            </div>
            <div
              style={{
                fontSize: 12,
                color: sub,
                fontStyle: 'italic',
                marginTop: 2,
              }}
            >
              {note}
            </div>
          </button>
        );
      })}
    </>
  );
}
